export default [{
        path: '/classfeed',
        name: 'classfeed',
        component: () =>
            import ('@/views/pages/classfeed/Classfeed.vue'),
        meta: {
            resource: 'Classfeed',
            action: 'read',
            pageTitle: 'Class Feed',
            // breadcrumb: [{
            //     text: 'Class Feed',
            //     active: true,
            // }, ],
        },
    },
    // {
    //     path: '/apps/teachersguide.pdf',
    //     name: 'teacherguidepdf',
    //     // href:'teachersguide.pdf',
    
    // },
    {
        path: '/announcements',
        name: 'announcements',
        component: () =>
            import ('@/views/acadevian/Announcements.vue'),
        meta: {
            resource: 'Classfeed',
            action: 'read',
            pageTitle: 'announcements',
            // breadcrumb: [{
            //     text: 'Class Feed',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/inactive',
        name: 'inactive',
        component: () =>
            import ('@/views/acadevian/NotActive.vue'),
        meta: {
            resource: 'Active',
            action: 'not',
            pageTitle: 'Not Active',
        },
    },
    {
        path: '/notifications',
        name: 'notifications',
        component: () =>
            import ('@/views/acadevian/Notifications.vue'),
        meta: {
            resource: 'notifications',
            action: 'read',
            pageTitle: 'Notifications',
        },
    },
    {
        path: '/school-regulations',
        name: 'schoolregulations',
        component: () =>
            import ('@/views/acadevian/schoolregulations.vue'),
        meta: {
            resource: 'National',
            action: 'read',
            pageTitle: 'School Regulations',
        },
    },
    {
        path: '/onlineclass',
        name: 'onlineclass',
        props: true,
        component: () =>
            import ('@/views/acadevian/onlineClass.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Online Class',
            // breadcrumb: [{
            //     text: 'Class Feed',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/imports',
        name: 'imports',
        component: () =>
            import ('@/views/acadevian/import.vue'),
        meta: {
            resource: 'All',
            action: 'manage',
            pageTitle: 'Imports',
            // breadcrumb: [{
            //     text: 'Subjects',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/exports',
        name: 'exports',
        component: () =>
            import ('@/views/acadevian/export.vue'),
        meta: {
            resource: 'All',
            action: 'manage',
            pageTitle: 'Exports',
            // breadcrumb: [{
            //     text: 'Subjects',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/print-cards',
        name: 'printcards',
        component: () =>
            import ('@/views/acadevian/printcards.vue'),
        meta: {
            resource: 'All',
            action: 'manage',
            pageTitle: 'Print Cards',
            // breadcrumb: [{
            //     text: 'Subjects',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/settings',
        name: 'settings',
        component: () =>
            import ('@/views/acadevian/settings.vue'),
        meta: {
            resource: 'All',
            action: 'manage',
            pageTitle: 'Settings',
            // breadcrumb: [{
            //     text: 'Subjects',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/qmatics',
        name: 'qmatics',
        component: () =>
            import ('@/views/acadevian/qmatic.vue'),
        meta: {
            action: 'read',
            resource: 'qmatics',
            pageTitle: 'Qmatics',
            // breadcrumb: [{
            //     text: 'Subjects',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/subjects',
        name: 'subjects',
        component: () =>
            import ('@/views/acadevian/subjects.vue'),
        meta: {
            resource: 'All',
            action: 'manage',
            pageTitle: 'Subjects',
            // breadcrumb: [{
            //     text: 'Subjects',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/grades',
        name: 'grades',
        component: () =>
            import ('@/views/acadevian/grades.vue'),
        meta: {
            resource: 'All',
            action: 'manage',
            pageTitle: 'grades',
            // breadcrumb: [{
            //     text: 'grades',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/classes',
        name: 'classes',
        component: () =>
            import ('@/views/acadevian/classes.vue'),
        meta: {
            action: 'read',
            resource: 'classes',
            pageTitle: 'classes',
            // breadcrumb: [{
            //     text: 'Classes',
            //     active: true,
            // }, ],
        },
    },

    {
        path: '/studentpermissions',
        name: 'studentpermissions',
        component: () =>
            import ('@/views/acadevian/StudentPermissions.vue'),
        meta: {
            resource: 'studentpermissions', //'StudentPermission',
            action: 'read',
            pageTitle: 'Student Permissions',
        },
    },
    {
        path: '/StudentPermission-details/:id',
        name: 'studentpermissionsdetails',
        props: true,
        component: () =>
            import ('@/views/acadevian/StudentPermissionDetails.vue'),
        meta: {
            resource: 'studentpermissions', // 'StudentPermission',
            action: 'read',
            pageTitle: 'Student Permission Details',
        },
    },
    {
        path: '/complaints',
        name: 'complaints',
        component: () =>
            import ('@/views/acadevian/complaints.vue'),
        meta: {
            resource: 'complaint',
            action: 'read',
            pageTitle: 'Complaints',
        },
    },
    {
        path: '/complaints-details/:id',
        name: 'complaintsdetails',
        props: true,
        component: () =>
            import ('@/views/acadevian/complaintDetails.vue'),
        meta: {
            resource: 'complaint',
            action: 'read',
            pageTitle: 'Complaint Details',
        },
    },
    {
        path: '/attendance',
        name: 'attendance',
        component: () =>
            import ('@/views/acadevian/attendance.vue'),
        meta: {
            resource: 'Attendance',
            action: 'write',
            pageTitle: 'Attendance',
            // breadcrumb: [{
            //     text: 'Classes',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/take-attendance',
        name: 'takeAttendance',
        component: () =>
            import ('@/views/acadevian/takeAttendance.vue'),
        props: true,
        meta: {
            resource: 'Attendance',
            action: 'write',
            pageTitle: 'Take Attendance',

        },
    },
    {
        path: '/edit-attendance',
        name: 'editAttendance',
        component: () =>
            import ('@/views/acadevian/editAttendance.vue'),
        props: true,
        meta: {
            resource: 'Attendance',
            action: 'write',
            pageTitle: 'Edit Attendance',
        },
    },
    {
        path: '/view-attendance',
        name: 'viewAttendance',
        component: () =>
            import ('@/views/acadevian/viewAttendance.vue'),
        props: true,
        meta: {
            resource: 'Attendance',
            action: 'write',
            pageTitle: 'View Attendance Details',
        },
    },
    {
        path: '/evaluation',
        name: 'evaluation',
        component: () =>
            import ('@/views/acadevian/evaluation/evaluation.vue'),
        meta: {
            resource: 'Evaluation',
            action: 'read',
            pageTitle: 'Evaluation',
            // breadcrumb: [{
            //     text: 'Classes',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/take-evaluation',
        name: 'takeEvaluation',
        component: () =>
            import ('@/views/acadevian/evaluation/takeEvaluation.vue'),
        props: true,
        meta: {
            resource: 'Evaluation',
            action: 'write',
            pageTitle: 'Take evaluation',

        },
    },
    {
        path: '/edit-evaluation',
        name: 'editEvaluation',
        component: () =>
            import ('@/views/acadevian/evaluation/editEvaluation.vue'),
        props: true,
        meta: {
            resource: 'Evaluation',
            action: 'write',
            pageTitle: 'Edit Evaluation',
        },
    },
    {
        path: '/view-evaluation',
        name: 'viewEvaluation',
        component: () =>
            import ('@/views/acadevian/evaluation/viewEvaluation.vue'),
        props: true,
        meta: {
            resource: 'Evaluation',
            action: 'read',
            pageTitle: 'View Evaluation Details',
        },
    },

    {
        path: '/exams',
        name: 'exams',
        component: () =>
            import ('@/views/acadevian/exams.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'exams',
            // breadcrumb: [{
            //     text: 'Classes',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/add-exams',
        name: 'addexams',
        component: () =>
            import ('@/views/acadevian/exams/ExamAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Add Exam',
        },
    },
    {
        path: '/edit-exams',
        name: 'editexams',
        props: true,
        component: () =>
            import ('@/views/acadevian/exams/ExamAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Add Exam',
        },
    },
    {
        path: '/take-exams',
        name: 'takeexams',
        props: true,
        component: () =>
            import ('@/views/acadevian/exams/takeExam.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Examining',
        },
    },
    {
        path: '/view-exams',
        name: 'viewexams',
        props: true,
        component: () =>
            import ('@/views/acadevian/exams/viewExam.vue'),
        meta: {
            resource: 'Exam',
            action: 'readanswers',
            pageTitle: 'Exam Model Answers',
        },
    },
    {
        path: '/online-exam-results',
        name: 'onlineexamresults', //students all results filterd by class and exam
        component: () =>
            import ('@/views/acadevian/onlineexamresults.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Exam Results',
        },
    },
    {
        path: '/online-exam-results-index',
        name: 'onlineexamresultsindex', //students all results filterd by class and exam
        component: () =>
            import ('@/views/acadevian/onlineexamresults-index.vue'),
        meta: {
            resource: 'resultsindex',
            action: 'read',
            pageTitle: 'Exam Results Index',
        },
    },
    {
        path: '/oer/:id',
        name: 'onlineexamresults-list', //students all results filterd by class and exam
        props: true,
        component: () =>
            import ('@/views/acadevian/onlineexamresultslist.vue'),
        meta: {
            resource: 'resultsindex',
            action: 'read',
            pageTitle: 'Exam Results',
        },
    },
    {
        path: '/student-results',
        name: 'studentresults',
        props: true,
        component: () =>
            import ('@/views/acadevian/exams/examResult.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Exam Result',
        },
    },
    {
        path: '/online-exam-results',
        name: 'examresult',
        props: true,
        component: () =>
            import ('@/views/acadevian/exams/examResult.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Exam Result',
        },
    },
    
    {
        path: '/study-materials',
        name: 'studymaterials',
        component: () =>
            import ('@/views/pages/classfeed/Classfeed.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Class Feed',
            // breadcrumb: [{
            //     text: 'Class Feed',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/study-materials-list',
        name: 'studymaterialslist',
        component: () =>
            import ('@/views/acadevian/studyMaterials.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'Study Materials',
            // breadcrumb: [{
            //     text: 'Class Feed',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/booklets',
        name: 'booklets',
        component: () =>
            import ('@/views/acadevian/booklets.vue'),
        meta: {
            resource: 'booklets',
            action: 'read',
            pageTitle: 'Booklets',
        },
    },

    {
        path: '/certificatelist/:id',
        name: 'certificates-list',
        props: true,
        component: () =>
            import ('@/views/acadevian/certificates/certificatedetails.vue'),
        meta: {
            resource: 'certificatelist',
            action: 'read',
        }
    }, {
        path: '/certificate/:id',
        name: 'certificates-details',
        props: true,
        component: () =>
            import ('@/views/acadevian/certificates/certificate.vue'),
        meta: {
            resource: 'Classfeed',
            action: 'read',
        }
    }, {
        path: '/edit-certificate/:id',
        name: 'certificates-edit',
        props: true,
        component: () =>
            import ('@/views/acadevian/certificates/certificateEdit.vue'),
        meta: {
            resource: 'certificatedetails',
            action: 'edit',
        }
    },
    {
        path: '/add-certificates-templates',
        name: 'add-certificates-templates',
        component: () =>
            import ('@/views/acadevian/certificates/addCertificateTemplate.vue'),
        meta: {
            resource: 'templates',
            action: 'create',
        }
    }, {
        path: '/edit-certificates-templates/:id',
        name: 'edit-certificates-templates',
        props: true,
        component: () =>
            import ('@/views/acadevian/certificates/editCertificateTemplate.vue'),
        meta: {
            resource: 'templates',
            action: 'edit',
        }
    },
    {
        path: '/certificates-templates',
        name: 'certificates-templates',
        component: () =>
            import ('@/views/acadevian/certificates/templates.vue'),
        meta: {
            resource: 'templates',
            action: 'read',
        }
    },
    {

        path: '/certificates',
        name: 'certificates',
        component: () =>
            import ('@/views/acadevian/certificates/certificates.vue'),
        meta: {
            resource: 'certificates',
            action: 'read',
        }

    },
    {

        path: '/certificates/add',
        name: 'certificates-add',
        component: () =>
            import ('@/views/acadevian/certificates/addCertificates.vue'),
        meta: {
            resource: 'certificates',
            action: 'create',
        }

    },
    {

        path: '/results/add',
        name: 'results-add',
        component: () =>
            import ('@/views/acadevian/certificates/addCertificates.vue'),
        meta: {
            resource: 'results',
            action: 'create'
        }

    },
    //start users
    {
        path: '/students/list',
        name: 'students-list',
        component: () =>
            import ('@/views/apps/user/users-list/UsersList.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
        }
    },
    {
        path: '/users',
        name: 'users',
        component: () =>
            import ('@/views/acadevian/users/users.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'users',
        },
    },
    {
        path: '/add-users',
        name: 'addusers',
        component: () =>
            import ('@/views/acadevian/users/usersAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add users',
        },
    },
    {
        path: '/edit-users',
        name: 'editusers',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/usersEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit users',
        },
    },
    {
        path: '/hods',
        name: 'hods',
        component: () =>
            import ('@/views/acadevian/users/hods.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'hods',
        },
    },
    {
        path: '/add-hods',
        name: 'addhods',
        component: () =>
            import ('@/views/acadevian/users/hodsAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add hods',
        },
    },
    {
        path: '/edit-hods',
        name: 'edithods',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/hodsEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit hods',
        },
    },
    {
        path: '/Principles',
        name: 'Principles',
        component: () =>
            import ('@/views/acadevian/users/Principles.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Principles',
        },
    },
    {
        path: '/add-Principles',
        name: 'addPrinciples',
        component: () =>
            import ('@/views/acadevian/users/PrinciplesAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add Principles',
        },
    },
    {
        path: '/edit-Principles',
        name: 'editPrinciples',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/PrinciplesEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit Principles',
        },
    },
    {
        path: '/students',
        name: 'students',
        component: () =>
            import ('@/views/acadevian/users/students.vue'),
        meta: {
            resource: 'Students',
            action: 'read',
            pageTitle: 'students',
        },
    },
    {
        path: '/add-student',
        name: 'addstudent',
        component: () =>
            import ('@/views/acadevian/users/studentsAdd.vue'),
        meta: {
            resource: 'Students',
            action: 'add',
            pageTitle: 'Add Student',
        },
    },
    {
        path: '/edit-student',
        name: 'editstudent',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/studentsEdit.vue'),
        meta: {
            resource: 'Students',
            action: 'edit',
            pageTitle: 'Edit Student',
        },
    },
    {
        path: '/teachers',
        name: 'teachers',
        component: () =>
            import ('@/views/acadevian/users/teachers.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'teachers',
        },
    },
    {
        path: '/add-teacher',
        name: 'addteacher',
        component: () =>
            import ('@/views/acadevian/users/teachersAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add teacher',
        },
    },
    {
        path: '/edit-teacher',
        name: 'editteacher',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/teachersEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit teacher',
        },
    },
    {
        path: '/parents',
        name: 'parents',
        component: () =>
            import ('@/views/acadevian/users/parents.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'parents',
        },
    },
    {
        path: '/add-parents',
        name: 'addparents',
        component: () =>
            import ('@/views/acadevian/users/parentsAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add parents',
        },
    },
    {
        path: '/edit-parents',
        name: 'editparents',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/parentsEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit parents',
        },
    },
    {
        path: '/employees',
        name: 'employees',
        component: () =>
            import ('@/views/acadevian/users/employees.vue'),
        meta: {
            resource: 'Users',
            action: 'write',
            pageTitle: 'employees',
        },
    },
    {
        path: '/add-employees',
        name: 'addemployees',
        component: () =>
            import ('@/views/acadevian/users/employeesAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add employees',
        },
    },
    {
        path: '/edit-employees',
        name: 'editemployees',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/employeesEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit employees',
        },
    },
    {
        path: '/admins',
        name: 'admins',
        component: () =>
            import ('@/views/acadevian/users/admins.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'admins',
        },
    },
    {
        path: '/add-admins',
        name: 'addadmins',
        component: () =>
            import ('@/views/acadevian/users/adminsAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add admins',
        },
    },
    {
        path: '/edit-admins',
        name: 'editadmins',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/adminsEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit admins',
        },
    },
    {
        path: '/gradesupervisors',
        name: 'gradesupervisors',
        component: () =>
            import ('@/views/acadevian/users/gradesupervisors.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Bus Supervisors',
        },
    },
    {
        path: '/add-gradesupervisors',
        name: 'addgradesupervisors',
        component: () =>
            import ('@/views/acadevian/users/gradesupervisorsAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add gradesupervisors',
        },
    },
    {
        path: '/edit-gradesupervisors',
        name: 'editgradesupervisors',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/gradesupervisorsEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit gradesupervisors',
        },
    },
    {
        path: '/supervisors',
        name: 'supervisors',
        component: () =>
            import ('@/views/acadevian/users/supervisors.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Bus Supervisors',
        },
    },
    {
        path: '/add-supervisors',
        name: 'addsupervisors',
        component: () =>
            import ('@/views/acadevian/users/supervisorsAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add supervisors',
        },
    },
    {
        path: '/edit-supervisors',
        name: 'editsupervisors',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/supervisorsEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit supervisors',
        },
    },
    {
        path: '/students-invoices',
        name: 'students-invoices',
        component: () =>
            import ('@/views/acadevian/studentsInvoices.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'students invoices',
        },
    }, {
        path: '/student-admissions',
        name: 'student-admissions',
        component: () =>
            import ('@/views/acadevian/studentsAdmissions.vue'),
        meta: {
            resource: 'ACL',
            action: 'read',
            pageTitle: 'students invoices',
        },
    },
    {
        path: '/finance-reports',
        name: 'financeReports',
        props: true,
        component: () =>
            import ('@/views/acadevian/finance/financeReports.vue'),
        meta: {
            resource: 'ACL',
            action: 'finance_reports',
            pageTitle: 'Finance Reports',
        },
    },
    {
        path: '/students-make-payment/:id',
        name: 'studentMakePayment',
        props: true,
        component: () =>
            import ('@/views/acadevian/finance/studentMakePayment.vue'),
        meta: {
            resource: 'ACL',
            action: 'make_payment',
            pageTitle: 'Make Payment',
        },
    },
    {
        path: '/student-receipts/:id',
        name: 'studentReceipts',
        props: true,
        component: () =>
            import ('@/views/acadevian/finance/studentReceipts.vue'),
        meta: {
            resource: 'ACL',
            action: 'show_receipts',
            pageTitle: 'Student Receipts',
        },
    },
    {
        path: '/credit-receipts/:id',
        name: 'creditReceipts',
        props: true,
        component: () =>
            import ('@/views/acadevian/finance/studentCreditReceipts.vue'),
        meta: {
            resource: 'ACL',
            action: 'show_receipts',
            pageTitle: 'Student Receipts',
        },
    },
    {
        path: '/admission-receipts/:id',
        name: 'admissionReceipts',
        props: true,
        component: () =>
            import ('@/views/acadevian/finance/studentAdmissionReceipts.vue'),
        meta: {
            resource: 'ACL',
            action: 'show_receipts',
            pageTitle: 'Student Receipts',
        },
    },
    {
        path: '/receipts/preview/:id',
        name: 'receipts-preview',
        component: () =>
            import ('@/views/acadevian/finance/InvoicePreview.vue'),
    },
    {
        path: '/credit-receipts/preview/:id',
        name: 'creditreceipts-preview',
        component: () =>
            import ('@/views/acadevian/finance/creditPreview.vue'),
    },

    {
        path: '/mycertificates',
        name: 'mycertificates',
        component: () =>
            import ('@/views/acadevian/certificates/certificatesStudent.vue'),
        meta: {
            resource: 'mycertificates',
            action: 'read',

            pageTitle: 'my certificates',
        },
    },
    {
        path: '/certificates/preview/:id',
        name: 'certificates-preview',
        component: () =>
            import ('@/views/acadevian/certificates/certificatesPreview.vue'),



    },
    {
        path: '/admission-receipts/preview/:id',
        name: 'admission-receipts-preview',
        props: true,
        component: () =>
            import ('@/views/acadevian/finance/studentAdmissionPreview.vue'),
    },

    {
        path: '/classes-invoices',
        name: 'classes-invoices',
        component: () =>
            import ('@/views/acadevian/classesInvoices.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'classes invoices',
        },
    },
    {
        path: '/grades-invoices',
        name: 'grades-invoices',
        component: () =>
            import ('@/views/acadevian/finance/gradesInvoices.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'grades invoices',
        },
    },
    {
        path: '/grades-reports',
        name: 'grades-reports',
        component: () =>
            import ('@/views/acadevian/finance/gradesReports.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'grades reports',
        },
    },
    {
        path: '/accountants',
        name: 'accountants',
        component: () =>
            import ('@/views/acadevian/accountants.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Accountants',
        },
    },
    {
        path: '/add-accountants',
        name: 'addaccountants',
        component: () =>
            import ('@/views/acadevian/users/accountantsAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add accountants',
        },
    },
    {
        path: '/edit-accountants',
        name: 'editaccountants',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/accountantsEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit accountants',
        },
    },
    {
        path: '/stage-admins',
        name: 'stageadmins',
        component: () =>
            import ('@/views/acadevian/users/stageadmin.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'stage-admins',
        },
    },
    {
        path: '/edit-stage-admins/:userId',
        name: 'editstageadmins',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/stageadminEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'stage-admins',
        },
    },
    {
        path: '/add-stage-admins',
        name: 'addstageadmins',
        component: () =>
            import ('@/views/acadevian/users/stageadminAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'stage-admins',
        },
    },
    {
        path: '/educational-debuties',
        name: 'debuties',
        component: () =>
            import ('@/views/acadevian/users/debuties.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'educational-debuties',
        },
    },
    {
        path: '/edit-educational-debuties/:userId',
        name: 'editdebuties',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/debutyEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'educational-debuties',
        },
    },
    {
        path: '/add-educational-debuties',
        name: 'adddebuties',
        component: () =>
            import ('@/views/acadevian/users/debutyAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'educational-debuties',
        },
    },
    {
        path: '/busdrivers',
        name: 'busdrivers',
        component: () =>
            import ('@/views/acadevian/users/busdrivers.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Bus drivers',
        },
    },
    {
        path: '/add-busdrivers',
        name: 'addbusdrivers',
        component: () =>
            import ('@/views/acadevian/users/busdriversAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add Busdrivers',
        },
    },
    {
        path: '/change-pasword/:userId',
        name: 'changeuserpassword',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/passwordChange.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Change Password',
        },
    },
    {
        path: '/edit-busdrivers/:userId',
        name: 'editbusdrivers',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/busdriversEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit Busdrivers',
        },
    },
    {
        path: '/showlatesttrip/:busId',
        name: 'showlatesttrip',
        props: true,
        component: () =>
            import ('@/views/acadevian/showLatesttrip.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Trip Details',
        },
    },

    {
        path: '/bussupervisors',
        name: 'bussupervisors',
        component: () =>
            import ('@/views/acadevian/users/bussupervisors.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Bus Supervisors',
        },
    },
    {
        path: '/add-bussupervisors',
        name: 'addbussupervisors',
        component: () =>
            import ('@/views/acadevian/users/bussupervisorsAdd.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Add bus supervisors',
        },
    },
    {
        path: '/edit-bussupervisors/:userId',
        name: 'editbussupervisors',
        props: true,
        component: () =>
            import ('@/views/acadevian/users/bussupervisorsEdit.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Edit bus supervisors',
        },
    },
    //end users
    {
        path: '/busses',
        name: 'busses',
        component: () =>
            import ('@/views/acadevian/busses.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Busses',
        },
    },
    {
        path: '/lines',
        name: 'buslines',
        component: () =>
            import ('@/views/acadevian/buslines.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Bus Lines',
        },
    },

    {
        path: '/bustracker',
        name: 'bustracker',
        component: () =>
            import ('@/views/acadevian/bustracker.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Busses Map',
        },
    },
    {
        path: '/employee-attendance',
        name: 'empattendance',
        component: () =>
            import ('@/views/acadevian/empattendance.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Employee Attendance',
            // breadcrumb: [{
            //     text: 'admins',
            //     active: true,
            // }, ],
        },
    },
    {
        path: '/devices',
        name: 'devices',
        component: () =>
            import ('@/views/acadevian/devices.vue'),
        meta: {
            resource: 'ACL',
            action: 'write',
            pageTitle: 'Devices',
            // breadcrumb: [{
            //     text: 'admins',
            //     active: true,
            // }, ],
        },
    }
]